import { useRef, useState } from "react";

import { useTranslation } from "@impero-com/common/utils/i18n";
import { TSTExpandableTable, TSTPagination } from "@impero-com/ui";

import { DebouncedSearchInput } from "components/DebouncedSearchInput";

import { ControlProgramTagsQuerySelect } from "../queries/useControlProgramTagsQuery";

import { ControlProgramTagsSubTable } from "./components/ControlProgramTagsSubTable";
import * as theme from "./theme.css";
import {
    CategoryOverview,
    getVisibleTags,
    useControlProgramTagsListTable,
} from "./useControlProgramTagsListTable";

interface DrawerProps {
    isDrawerOpen: boolean;
    setIsDrawerOpen: (isOpen: boolean) => void;
    setSelectedCategory: (category: CategoryOverview) => void;
}

export function ControlProgramTagsList({
    tags,
    tagCategories,
    setIsDrawerOpen,
    setSelectedCategory,
}: ControlProgramTagsQuerySelect & DrawerProps) {
    const { t } = useTranslation();
    const [globalFilter, setGlobalFilter] = useState("");
    const { table } = useControlProgramTagsListTable(
        tags,
        tagCategories,
        globalFilter,
        setGlobalFilter,
        setIsDrawerOpen,
        setSelectedCategory
    );
    const tableElement = useRef<HTMLDivElement>(null);
    return (
        <div>
            <div className={theme.tableFilter}>
                <DebouncedSearchInput
                    globalSearchLabel={t("FilterBar_GlobalSearchPlaceholder")}
                    onGlobalSearchChange={setGlobalFilter}
                    getGlobalSearchValue={() => globalFilter}
                />
            </div>

            <TSTExpandableTable
                tableRef={tableElement}
                table={table}
                noResultsFallback={t("NoResults")}
                noSourceRowsFallback={t("NoResults")}
                renderSubComponent={(row: CategoryOverview) => (
                    <ControlProgramTagsSubTable
                        tags={getVisibleTags(row, globalFilter)}
                        tableElement={tableElement}
                    />
                )}
            />
            <TSTPagination
                table={table}
                pageLabel={t("Pagination_Page")}
                getRowCountLabel={(shown, count) =>
                    t("Pagination_RowCount", { shown, count })
                }
                getSinglePageRowCountLabel={(count) =>
                    t("Pagination_RowCountSinglePage", { count })
                }
                tableElement={tableElement}
            />
        </div>
    );
}
